import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Navigation, Pagination, Scrollbar, A11y } from 'swiper/modules';
import { ChevronDown, ChevronUp } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";


import './hero.scss'
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/scrollbar';
import { useEffect, useRef, useState } from 'react';
import { NavLink } from 'react-router-dom';
import BannerSkeleton from '../SkeletonLoaders/BannerSkeleton';
import { Banner, ProductCategory } from '../../interface/interfaces';
import CategorySkeleton from '../SkeletonLoaders/CategorySkeleton';


type Props = {
    isBannerLoading: boolean,
    categories: ProductCategory[],
    bannersData: Banner[]
}

const HeroSection = ({ isBannerLoading, categories, bannersData }: Props) => {

    const [toggleCategory, setToggleCategory] = useState(false)
    const [topSevenCategory, setTopSevenCategory] = useState<ProductCategory[]>([])

    const dropdownRef = useRef<HTMLDivElement>(null);
    const dropdownClicker = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const arr = categories.slice(0, 7);
        setTopSevenCategory(arr);
    }, [categories])



    useEffect(() => {
        const handleClickOutside = (event: MouseEvent) => {
            if (
                toggleCategory &&
                dropdownRef.current &&
                dropdownClicker.current &&
                !dropdownRef.current.contains(event.target as Node) &&
                !dropdownClicker.current.contains(event.target as Node)
            ) {
                setToggleCategory(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [toggleCategory]);

    return (
        <div className="herosection">

            <div className='gridTwo'>

                <div className='category'>

                    <div className='category_title' id='ispc'>
                        <div className='icon menu'></div>
                        <div>Shop by categories</div>


                    </div>

                    <div className='category_title' id='ismob' ref={dropdownClicker} onClick={() => setToggleCategory((prev) => !prev)}>

                        <div className='flex_center' style={{ gap: "10px" }}>
                            <div className='icon menu'></div>
                            <div>Shop by categories</div>
                        </div>


                        <div className='flex_center'>

                            {!toggleCategory && (<ChevronDown size={30}></ChevronDown>)}
                            {toggleCategory && (<ChevronUp size={30}></ChevronUp>)}

                        </div>

                    </div>

                    <div className='category_nav' id='pccategory'>

                        {isBannerLoading && (
                            <>
                                <CategorySkeleton></CategorySkeleton>
                                {/* <CategorySkeleton></CategorySkeleton> */}
                            </>

                        )}

                        {!isBannerLoading && (<>
                            {topSevenCategory.map((data) => (
                                <NavLink to={`/products/${data.tag}`}>
                                    <div className='each_category'>

                                        {/* <div className='svgicon'>

                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.5 4.79999C12.2517 4.79997 12.0096 4.87694 11.8069 5.02029C11.6042 5.16364 11.451 5.36631 11.3684 5.60039C11.3115 5.74536 11.2006 5.86256 11.0589 5.92722C10.9172 5.99189 10.756 5.99894 10.6092 5.94691C10.4625 5.89487 10.3417 5.78781 10.2724 5.64836C10.2031 5.50891 10.1908 5.34798 10.238 5.19959C10.3565 4.86466 10.548 4.56025 10.7986 4.30832C11.0491 4.05638 11.3524 3.86322 11.6867 3.74277C12.021 3.62232 12.3778 3.57759 12.7314 3.6118C13.0851 3.64601 13.4267 3.75832 13.7317 3.94061C14.0367 4.12291 14.2974 4.37064 14.4949 4.66593C14.6925 4.96121 14.8221 5.29669 14.8743 5.64813C14.9265 5.99958 14.9 6.35823 14.7967 6.69819C14.6935 7.03815 14.516 7.35094 14.2772 7.61399C14.1628 7.73879 14.0544 7.85399 13.952 7.95959C13.7636 8.15639 13.592 8.33399 13.4336 8.54039C13.2032 8.84039 13.1012 9.08039 13.1012 9.29999C13.1011 9.46315 13.1454 9.62325 13.2293 9.76318C13.3132 9.90311 13.4336 10.0176 13.5776 10.0944L20.9888 14.0472C21.402 14.2676 21.7296 14.6199 21.9196 15.0479C22.1097 15.476 22.1511 15.9553 22.0375 16.4096C21.9238 16.8639 21.6616 17.2672 21.2924 17.5554C20.9232 17.8436 20.4683 18.0001 20 18H4.99996C4.53163 18.0001 4.07671 17.8436 3.70753 17.5554C3.33835 17.2672 3.07609 16.8639 2.96243 16.4096C2.84878 15.9553 2.89026 15.476 3.08028 15.0479C3.2703 14.6199 3.59796 14.2676 4.01116 14.0472L10.418 10.6308C10.4877 10.5905 10.5648 10.5647 10.6447 10.5548C10.7246 10.545 10.8057 10.5513 10.8832 10.5735C10.9606 10.5956 11.0327 10.6331 11.0954 10.6837C11.158 10.7344 11.2098 10.7971 11.2476 10.8681C11.2855 10.9392 11.3087 11.0172 11.3158 11.0974C11.3229 11.1776 11.3138 11.2584 11.289 11.335C11.2642 11.4116 11.2242 11.4825 11.1715 11.5433C11.1187 11.6042 11.0543 11.6538 10.982 11.6892L4.57636 15.1056C4.39911 15.2 4.25851 15.3509 4.17694 15.5344C4.09538 15.7179 4.07753 15.9234 4.12623 16.1183C4.17494 16.3131 4.2874 16.486 4.44572 16.6096C4.60405 16.7331 4.79914 16.8001 4.99996 16.8H20C20.2008 16.8001 20.3959 16.7331 20.5542 16.6096C20.7125 16.486 20.825 16.3131 20.8737 16.1183C20.9224 15.9234 20.9045 15.7179 20.823 15.5344C20.7414 15.3509 20.6008 15.2 20.4236 15.1056L13.0124 11.1528C12.6767 10.9736 12.3959 10.7066 12.2002 10.3802C12.0045 10.0539 11.9011 9.68052 11.9012 9.29999C11.9012 8.69159 12.1856 8.19359 12.482 7.80839C12.68 7.55159 12.932 7.28879 13.1456 7.06439C13.2368 6.97079 13.318 6.88479 13.3892 6.80639C13.5454 6.63426 13.6482 6.42048 13.6852 6.19101C13.7222 5.96155 13.6918 5.72627 13.5976 5.51378C13.5034 5.30128 13.3496 5.12071 13.1547 4.99399C12.9598 4.86728 12.7324 4.79988 12.5 4.79999Z" fill="#717171" />
                                        </svg>

                                    </div> */}

                                        <div></div>

                                        <div className='text'>{data.name}</div>

                                    </div>
                                </NavLink>
                            ))}

                            <NavLink to={`/products`}>

                                <div className='each_category'>
                                    <div className='svgicon'>
                                        {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.14281 12C8.14281 12.341 8.00735 12.668 7.76623 12.9091C7.52511 13.1503 7.19808 13.2857 6.85709 13.2857C6.5161 13.2857 6.18907 13.1503 5.94795 12.9091C5.70684 12.668 5.57138 12.341 5.57138 12C5.57138 11.659 5.70684 11.332 5.94795 11.0909C6.18907 10.8498 6.5161 10.7143 6.85709 10.7143C7.19808 10.7143 7.52511 10.8498 7.76623 11.0909C8.00735 11.332 8.14281 11.659 8.14281 12ZM13.2857 12C13.2857 12.341 13.1502 12.668 12.9091 12.9091C12.668 13.1503 12.3409 13.2857 11.9999 13.2857C11.659 13.2857 11.3319 13.1503 11.0908 12.9091C10.8497 12.668 10.7142 12.341 10.7142 12C10.7142 11.659 10.8497 11.332 11.0908 11.0909C11.3319 10.8498 11.659 10.7143 11.9999 10.7143C12.3409 10.7143 12.668 10.8498 12.9091 11.0909C13.1502 11.332 13.2857 11.659 13.2857 12ZM18.4285 12C18.4285 12.341 18.2931 12.668 18.0519 12.9091C17.8108 13.1503 17.4838 13.2857 17.1428 13.2857C16.8018 13.2857 16.4748 13.1503 16.2337 12.9091C15.9925 12.668 15.8571 12.341 15.8571 12C15.8571 11.659 15.9925 11.332 16.2337 11.0909C16.4748 10.8498 16.8018 10.7143 17.1428 10.7143C17.4838 10.7143 17.8108 10.8498 18.0519 11.0909C18.2931 11.332 18.4285 11.659 18.4285 12ZM11.9999 1.71429C6.31966 1.71429 1.71423 6.31972 1.71423 12C1.71423 17.6803 6.31966 22.2857 11.9999 22.2857C17.6802 22.2857 22.2857 17.6803 22.2857 12C22.2857 6.31972 17.6802 1.71429 11.9999 1.71429ZM2.99995 12C2.99995 7.02944 7.02938 3.00001 11.9999 3.00001C16.9705 3.00001 20.9999 7.02944 20.9999 12C20.9999 16.9706 16.9705 21 11.9999 21C7.02938 21 2.99995 16.9706 2.99995 12Z" fill="#717171" />
                                    </svg> */}

                                    </div>
                                    <div className='text'>More categories</div>
                                </div>

                            </NavLink>
                        </>)}

                    </div>

                    <AnimatePresence>
                        {toggleCategory && (
                            <motion.div
                                initial={{ opacity: 0, y: -10, height: 0 }}
                                animate={{
                                    opacity: 1, y: 0, height: "auto", transition: {
                                        type: "spring",
                                        stiffness: 400,
                                        damping: 20,
                                        bounce: 0.3,
                                    }
                                }}
                                exit={{
                                    opacity: 0, y: -10, height: 0, transition: {
                                        type: "tween",
                                        duration: 0.2,
                                        ease: "easeInOut",
                                    }
                                }}

                            >
                                <div className='category_nav' id='mobcategory' ref={dropdownRef}>

                                    {isBannerLoading && (
                                        <>
                                            <CategorySkeleton></CategorySkeleton>
                                            {/* <CategorySkeleton></CategorySkeleton> */}
                                        </>

                                    )}

                                    {!isBannerLoading && (<>
                                        {topSevenCategory.map((data) => (
                                            <NavLink to={`/products/${data.tag}`}>
                                                <div className='each_category'>

                                                    {/* <div className='svgicon'>

                                        <svg width="25" height="24" viewBox="0 0 25 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M12.5 4.79999C12.2517 4.79997 12.0096 4.87694 11.8069 5.02029C11.6042 5.16364 11.451 5.36631 11.3684 5.60039C11.3115 5.74536 11.2006 5.86256 11.0589 5.92722C10.9172 5.99189 10.756 5.99894 10.6092 5.94691C10.4625 5.89487 10.3417 5.78781 10.2724 5.64836C10.2031 5.50891 10.1908 5.34798 10.238 5.19959C10.3565 4.86466 10.548 4.56025 10.7986 4.30832C11.0491 4.05638 11.3524 3.86322 11.6867 3.74277C12.021 3.62232 12.3778 3.57759 12.7314 3.6118C13.0851 3.64601 13.4267 3.75832 13.7317 3.94061C14.0367 4.12291 14.2974 4.37064 14.4949 4.66593C14.6925 4.96121 14.8221 5.29669 14.8743 5.64813C14.9265 5.99958 14.9 6.35823 14.7967 6.69819C14.6935 7.03815 14.516 7.35094 14.2772 7.61399C14.1628 7.73879 14.0544 7.85399 13.952 7.95959C13.7636 8.15639 13.592 8.33399 13.4336 8.54039C13.2032 8.84039 13.1012 9.08039 13.1012 9.29999C13.1011 9.46315 13.1454 9.62325 13.2293 9.76318C13.3132 9.90311 13.4336 10.0176 13.5776 10.0944L20.9888 14.0472C21.402 14.2676 21.7296 14.6199 21.9196 15.0479C22.1097 15.476 22.1511 15.9553 22.0375 16.4096C21.9238 16.8639 21.6616 17.2672 21.2924 17.5554C20.9232 17.8436 20.4683 18.0001 20 18H4.99996C4.53163 18.0001 4.07671 17.8436 3.70753 17.5554C3.33835 17.2672 3.07609 16.8639 2.96243 16.4096C2.84878 15.9553 2.89026 15.476 3.08028 15.0479C3.2703 14.6199 3.59796 14.2676 4.01116 14.0472L10.418 10.6308C10.4877 10.5905 10.5648 10.5647 10.6447 10.5548C10.7246 10.545 10.8057 10.5513 10.8832 10.5735C10.9606 10.5956 11.0327 10.6331 11.0954 10.6837C11.158 10.7344 11.2098 10.7971 11.2476 10.8681C11.2855 10.9392 11.3087 11.0172 11.3158 11.0974C11.3229 11.1776 11.3138 11.2584 11.289 11.335C11.2642 11.4116 11.2242 11.4825 11.1715 11.5433C11.1187 11.6042 11.0543 11.6538 10.982 11.6892L4.57636 15.1056C4.39911 15.2 4.25851 15.3509 4.17694 15.5344C4.09538 15.7179 4.07753 15.9234 4.12623 16.1183C4.17494 16.3131 4.2874 16.486 4.44572 16.6096C4.60405 16.7331 4.79914 16.8001 4.99996 16.8H20C20.2008 16.8001 20.3959 16.7331 20.5542 16.6096C20.7125 16.486 20.825 16.3131 20.8737 16.1183C20.9224 15.9234 20.9045 15.7179 20.823 15.5344C20.7414 15.3509 20.6008 15.2 20.4236 15.1056L13.0124 11.1528C12.6767 10.9736 12.3959 10.7066 12.2002 10.3802C12.0045 10.0539 11.9011 9.68052 11.9012 9.29999C11.9012 8.69159 12.1856 8.19359 12.482 7.80839C12.68 7.55159 12.932 7.28879 13.1456 7.06439C13.2368 6.97079 13.318 6.88479 13.3892 6.80639C13.5454 6.63426 13.6482 6.42048 13.6852 6.19101C13.7222 5.96155 13.6918 5.72627 13.5976 5.51378C13.5034 5.30128 13.3496 5.12071 13.1547 4.99399C12.9598 4.86728 12.7324 4.79988 12.5 4.79999Z" fill="#717171" />
                                        </svg>

                                    </div> */}

                                                    <div></div>

                                                    <div className='text'>{data.name}</div>

                                                </div>
                                            </NavLink>
                                        ))}

                                        <NavLink to={`/products`}>

                                            <div className='each_category'>
                                                <div className='svgicon'>
                                                    {/* <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M8.14281 12C8.14281 12.341 8.00735 12.668 7.76623 12.9091C7.52511 13.1503 7.19808 13.2857 6.85709 13.2857C6.5161 13.2857 6.18907 13.1503 5.94795 12.9091C5.70684 12.668 5.57138 12.341 5.57138 12C5.57138 11.659 5.70684 11.332 5.94795 11.0909C6.18907 10.8498 6.5161 10.7143 6.85709 10.7143C7.19808 10.7143 7.52511 10.8498 7.76623 11.0909C8.00735 11.332 8.14281 11.659 8.14281 12ZM13.2857 12C13.2857 12.341 13.1502 12.668 12.9091 12.9091C12.668 13.1503 12.3409 13.2857 11.9999 13.2857C11.659 13.2857 11.3319 13.1503 11.0908 12.9091C10.8497 12.668 10.7142 12.341 10.7142 12C10.7142 11.659 10.8497 11.332 11.0908 11.0909C11.3319 10.8498 11.659 10.7143 11.9999 10.7143C12.3409 10.7143 12.668 10.8498 12.9091 11.0909C13.1502 11.332 13.2857 11.659 13.2857 12ZM18.4285 12C18.4285 12.341 18.2931 12.668 18.0519 12.9091C17.8108 13.1503 17.4838 13.2857 17.1428 13.2857C16.8018 13.2857 16.4748 13.1503 16.2337 12.9091C15.9925 12.668 15.8571 12.341 15.8571 12C15.8571 11.659 15.9925 11.332 16.2337 11.0909C16.4748 10.8498 16.8018 10.7143 17.1428 10.7143C17.4838 10.7143 17.8108 10.8498 18.0519 11.0909C18.2931 11.332 18.4285 11.659 18.4285 12ZM11.9999 1.71429C6.31966 1.71429 1.71423 6.31972 1.71423 12C1.71423 17.6803 6.31966 22.2857 11.9999 22.2857C17.6802 22.2857 22.2857 17.6803 22.2857 12C22.2857 6.31972 17.6802 1.71429 11.9999 1.71429ZM2.99995 12C2.99995 7.02944 7.02938 3.00001 11.9999 3.00001C16.9705 3.00001 20.9999 7.02944 20.9999 12C20.9999 16.9706 16.9705 21 11.9999 21C7.02938 21 2.99995 16.9706 2.99995 12Z" fill="#717171" />
                                    </svg> */}

                                                </div>
                                                <div className='text'>More categories</div>
                                            </div>

                                        </NavLink>
                                    </>)}


                                </div>
                            </motion.div>
                        )}
                    </AnimatePresence>


                </div>


                <div className='content_section'>

                    <div className='nav'>
                        <NavLink to={'/'}><div className='each_nav active'>Home</div></NavLink>
                        <NavLink to={'/products'}><div className='each_nav'>Shop </div></NavLink>
                       

                        {/* <div className='each_nav'>Features</div>
                        <div className='each_nav'>Hot offers</div>
                        <div className='each_nav'>Pages</div>
                        <div className='each_nav'>Blog</div>
                        <div className='each_nav'>About</div>
                        <div className='each_nav'>Contact Us</div> */}
                    </div>

                    <AnimatePresence mode='wait'>
                        {isBannerLoading && (
                            <motion.div initial={{ opacity: 0 }}
                                animate={{ opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }}
                                exit={{ opacity: 0 }} className='slideshow'>
                                <BannerSkeleton></BannerSkeleton>
                            </motion.div>
                        )}

                        {!isBannerLoading && (
                            <motion.div initial={{ opacity: 0 }}
                                animate={{ opacity: 1, transition: { duration: 0.5, ease: "easeOut" } }}
                                exit={{ opacity: 0 }} className='slideshow'>
                                <Swiper
                                    modules={[Autoplay, Navigation, Pagination, Scrollbar, A11y]}
                                    spaceBetween={22}
                                    slidesPerView={1}
                                    navigation
                                    pagination={{ clickable: true }}
                                    // scrollbar={{ draggable: true }}
                                    // onSwiper={(swiper: any) => {}}
                                    // onSlideChange={() => {}}
                                    autoplay={{
                                        delay: 2500,
                                        disableOnInteraction: true,
                                    }}

                                    breakpoints={{
                                        0: { spaceBetween: 20 },
                                        650: { spaceBetween: 22 },

                                    }}
                                >



                                    <SwiperSlide>
                                        <div className='banner banner_one'>

                                            <div className='bannercontent'>
                                                <div className='bannertext'>
                                                    <div className='title'>Find the best gadgets!</div>
                                                    <div className='text'>Get the latest gadgets with the best prices in the market.</div>
                                                </div>
                                                <NavLink to={'/products'}><div className='bannerbtn'>Shop now</div></NavLink>
                                            </div>

                                        </div>
                                    </SwiperSlide>


                                    {bannersData.map((data, idx) => (
                                        <SwiperSlide key={idx}>
                                            <div className='bannerDynamic'>

                                                {/* <BannerImage width={600} height={470} src={data.image}></BannerImage> */}

                                                <div className='bannerImage' style={{ backgroundImage: `url(${data.image})` }}></div>

                                                <div className='boverlay'>

                                                    <div className='bannercontentDynamic'>
                                                        <div className='bannertextDynamic'>
                                                            <div className='title'>{data.hero_text}</div>
                                                            <div className='titletwo'>{data.advert_text}</div>
                                                            <div className='text'>{data.description}</div>
                                                        </div>
                                                        {data.product && (
                                                            <NavLink to={`/product/${data.product.id}`} style={{ width: 'fit-content' }}><div className='bannerbtn'>Shop now</div></NavLink>
                                                        )}

                                                    </div>
                                                </div>



                                            </div>
                                        </SwiperSlide>
                                    ))}

                                    {/* <SwiperSlide>
                                        <div className='banner'></div>
                                    </SwiperSlide>

                                    <SwiperSlide>
                                        <div className='banner'></div>
                                    </SwiperSlide> */}

                                </Swiper>
                            </motion.div>
                        )}
                    </AnimatePresence>






                </div>

            </div>



            <div className='features_tab'>

                <div className='each_feature'>
                    <div className='icon headphone'></div>
                    <div className='text'>Online Support</div>
                </div>

                <div className='each_feature'>
                    <div className='icon fast_bus'></div>
                    <div className='text'>Fast Delivery</div>
                </div>

                <div className='each_feature'>
                    <div className='icon secure'></div>
                    <div className='text'>Secure Payment</div>
                </div>

                <div className='each_feature'>
                    <div className='icon card_outline'></div>
                    <div className='text'>Money Gurantee</div>
                </div>

                <div className='each_feature'>
                    <div className='icon return_truck'></div>
                    <div className='text'>Free Returns</div>
                </div>

            </div>

        </div>
    )

}

export default HeroSection;